var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',_vm._b({staticClass:"global-umr-list__pagination m-0",attrs:{"per-page":_vm.pagination.page_size,"value":_vm.pagination.page,"align":"center"},on:{"input":_vm.onPaginate}},'b-pagination',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }